import styled from "styled-components"
import { Colors } from 'styles/app-styles'
import DataTable_s from "components/table/data-table-styles"

export const RentRoll_s = styled.div`
  min-height: calc(100vh);
  overflow: auto !important;
  position: fixed;
  width: 100%;

  .p-paginator {
    bottom: 30px;
    .p-connected-overlay-enter-done { background: white; }
  }
  .rent-roll-table-container {
    height: 100%;
  }
  .p-datatable-scrollable-wrapper {
    height: 100%;
    margin-bottom: 14px;
  }
  .p-datatable-scrollable-body {
    min-height: 300px;
  }
  .vertical-resizable-container {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 212px);
    width: 100%;
  }

  .panel {
    overflow: auto;
    box-sizing: border-box;
  }

  .horizontal-divider {
    height: 5px;
    cursor: ns-resize;
    background-color: #c5d7dc;
    position: relative;
    z-index: 10;
  }

  .horizontal-divider::after {
    content: 'Report';
    position: absolute;
    top: -16px;
    left: 2%;
    transform: translateX(-50%);
    font-size: 12px;
    background-color: #c5d7dc;
    color: black;
    padding: 2px 5px;
    border-radius: 3px;
  }

  .horizontal-divider:hover {
    background-color: #b8c4d1;
  }
  .horizontal-divider:hover::after {
    background-color: #b8c4d1;
  }
`

export const RentRollReport_s = styled.div`
  height: 99%;
  padding: 10px;
`

export const RentRollTable_s = styled(DataTable_s)`
  border-spacing: 15px;
  height: 100%;
  padding-bottom: 0 !important;

  table.p-datatable-scrollable-header-table, table.p-datatable-scrollable-body-table {
    width: auto;
  }

  table.p-datatable-scrollable-body-table {
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  }

  .p-datatable-thead > tr {
    height: 30px;
  }

  .systemImmutable-row {
    background: ${Colors.athensGrey} !important;
  }
  .system-row .system-disabled {
    background: ${Colors.athensGrey};
  }

  .billion-input {
    width: 120px;
  }
  .date-allow-relative {
    width: 160px;
  }
  .ti-amttype {
    width: 250px;
  }
  .named-item-state-input {
    width: 200px;
  }
  .lc-amount-type {
    width:200px;
  }
  .recoverypool {
    width: 310px;
  }
  .reporttag {
    width: 120px;
  }
  .pro-rata-type {
    width: 114px;
  }
  .pro-rata-percent {
    width: 66px;
  }
  .stop-type {
    width: 146px;
  }
  .stop {
    width: 100px;
  }
  .short-input {
    width: 100px;
  }

  // Rent roll sort hack
  .suite, .name, .area {
    > span.p-column-title:after {
      background: url('/icon-sort.svg');
      content: '';
      cursor: pointer;
      display: block;
      margin-right: 0;
      height: 24px;
      position: relative;
      width: 24px;
    }
  }
  .area > span.p-column-title::after {
    margin: -26px 2px 0 30px;
  }
  .suite > span.p-column-title::after {
    margin: -26px 2px 0 34px;
  }
  .name > span.p-column-title::after {
    margin: -26px 2px 0 40px;
  }

  // Detailed Amt //

  .detailed-amt-container {
    height: 400px;
  }

  // Pro Rata //

  .pro-rata-container {
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr;
    height: 470px;
    width: 100%;
    .cap-details {
      max-height: 245px;
      overflow: auto;
    }
  }
  .pro-rata-form {
    align-items: flex-start;
    grid-area: 1 / 1 / 2 / 3;
    z-index: 1;
  }

  //Footer
  .selection-count {
    bottom: -9px;
    font-size: smaller;
    position: relative;
    z-index: 999;
  }
`

export const OverrideIndicator_s = styled.div`
  &:after {
    border-radius: 100%;
    background-color: ${Colors.denim};
    content: "";
    height: 8px;
    margin-left: 4px;
    position: absolute;
    width: 8px;
  }
`